module.exports = __webpack_public_path__ + "img/3-1.0f6fc419.jpg";